export const countryOptions = [
    {
        label: 'United Kingdom',
        value: 'uk'
    },
    {
        label: 'Germany',
        value: 'de'
    },
    {
        label: 'Poland',
        value: 'pl'
    },
    {
        label: 'Spain',
        value: 'es'
    },
    {
        label: 'Other',
        value: 'other'
    }
];
